import CampaignsRoot from './Campaigns';
import Campaign from './Campaign';
import OrdersRoot from '../orders/Orders';
import PromotionsRoot from '../promotions/Promotions';
import CampaignDetails from'./CampaignDetails/CampaignDetails';
import CampaignMarketing from'./CampaignMarketing/CampaignMarketing';

const CampaignsListAll = () => import(/* webpackChunkName: "campaigns" */ './CampaignsList/CampaignsListTypeAll');
const CampaignsListDrafts = () => import(/* webpackChunkName: "campaigns" */ './CampaignsList/CampaignsListTypeDrafts');

const CampaignDashboard = () => import(/* webpackChunkName: "campaigns" */ './CampaignDashboard/CampaignDashboard');

const CampaignDetailsInfo = () => import(/* webpackChunkName: "campaigns" */ './CampaignDetails/CampaignDetailsInfo');
const CampaignDetailsUpsells = () => import(/* webpackChunkName: "campaigns" */ './CampaignDetails/CampaignDetailsUpsells');
const CampaignDetailsCrossSells = () => import(/* webpackChunkName: "campaigns" */ './CampaignDetails/CampaignDetailsCrossSells');
const CampaignDetailsProducts = () => import(/* webpackChunkName: "campaigns" */ './CampaignDetails/CampaignDetailsProducts');

const OrdersList = () => import(/* webpackChunkName: "orders" */ '../orders/OrdersList');
const OrderDetails = () => import(/* webpackChunkName: "orders" */ '../orders/OrderDetails');

const PromotionsList = () => import(/* webpackChunkName: "promotions" */ '../promotions/PromotionsList');
const PromotionsCreateUpdate = () => import(/* webpackChunkName: "promotions" */ '../promotions/PromotionsCreateUpdate');

const CampaignMarketingTracking = () => import(/* webpackChunkName: "campaigns" */ './CampaignMarketing/CampaignMarketingTracking');
const CampaignMarketingEmail = () => import(/* webpackChunkName: "campaigns" */ './CampaignMarketing/CampaignMarketingEmail');
const CampaignMarketingSeo = () => import(/* webpackChunkName: "campaigns" */ './CampaignMarketing/CampaignMarketingSeo');
const CampaignMarketingUrlBuilder = () => import(/* webpackChunkName: "campaigns" */ './CampaignMarketing/CampaignMarketingUrlBuilder');

const CampaignAssets = () => import(/* webpackChunkName: "campaigns" */ './CampaignAssets/CampaignAssets');

const CampaignRelaunchDashboard = () => import(/* webpackChunkName: "campaigns" */ './CampaignRelaunchDashboard/CampaignRelaunchDashboard');

const CampaignAds = () => import(/* webpackChunkName: "campaigns" */ './CampaignAds/CampaignAds');

export default {
  path: '/campaigns',
  name: 'campaigns',
  redirect: '/campaigns/all',
  component: CampaignsRoot,
  children: [{
    path: 'drafts',
    name: 'campaignsDrafts',
    component: CampaignsListDrafts
  }, {
    path: 'all',
    name: 'campaignsAll',
    component: CampaignsListAll
  }, {
    path: ':campaignId',
    name: 'campaign',
    redirect: '/campaigns/:campaignId/details',
    component: Campaign,
    props: true,
    children: [{
      path: 'details',
      name: 'campaignsDetails',
      redirect: '/campaigns/:campaignId/details/info',
      component: CampaignDetails,
      props: true,
      children: [{
        path: 'info',
        name: 'campaignsDetailsInfo',
        component: CampaignDetailsInfo,
        props: true
      }, {
        path: 'upsells',
        name: 'campaignsDetailsUpsells',
        component: CampaignDetailsUpsells,
        props: true
      }, {
        path: 'cross-sells',
        name: 'campaignsDetailsCrosssells',
        component: CampaignDetailsCrossSells,
        props: true
      }, {
        path: 'products',
        name: 'campaignsDetailsProducts',
        component: CampaignDetailsProducts,
        props: true
      }]
    }, {
      path: 'marketing',
      name: 'campaignsMarketing',
      redirect: '/campaigns/:campaignId/marketing/tracking',
      component: CampaignMarketing,
      props: true,
      children: [{
        path: 'email',
        name: 'campaignsMarketingEmail',
        component: CampaignMarketingEmail,
        props: true,
      }, {
        path: 'seo',
        name: 'campaignsMarketingSeo',
        component: CampaignMarketingSeo,
        props: true,
      }, {
        path: 'tracking',
        name: 'campaignsMarketingTracking',
        component: CampaignMarketingTracking,
        props: true,
      }, {
        path: 'url-builder',
        name: 'campaignsMarketingUrlbuilder',
        component: CampaignMarketingUrlBuilder,
        props: true,
      }]
    }, {
      path: 'analytics',
      name: 'campaignsAnalytics',
      component: CampaignDashboard,
      props: true
    }, {
      path: 'orders',
      name: 'campaignsOrders',
      redirect: '/campaigns/:campaignId/orders/all',
      component: OrdersRoot,
      props: true,
      children: [{
        path: 'all',
        name: 'campaignsOrdersAll',
        component: OrdersList,
        props: true
      }, {
        path: 'breakdown',
        name: 'campaignsOrdersBreakdown',
        component: OrdersList,
        props: true
      }, {
        path: ':orderId/details',
        name: 'campaignsOrdersDetails',
        component: OrderDetails,
        props: true,
      }]
    }, {
      path: 'coupons',
      name: 'campaignsPromotions',
      redirect: '/campaigns/:campaignId/coupons/all',
      component: PromotionsRoot,
      props: true,
      children: [{
        path: 'all',
        name: 'campaignsPromotionsAll',
        component: PromotionsList,
        props: true
      }, {
        path: ':promotionId/edit',
        name: 'campaignsPromotionsEdit',
        component: PromotionsCreateUpdate,
        props: true
      }, {
        path: 'create',
        name: 'campaignsPromotionsCreate',
        component: PromotionsCreateUpdate,
        props: true
      }]
    }, {
      path: 'assets',
      name: 'campaignsAssets',
      component: CampaignAssets,
      props: true,
    }, {
      path: 'relaunches',
      name: 'campaignsRelaunches',
      component: CampaignRelaunchDashboard,
      props: true,
    }, {
      path: 'ads',
      name: 'campaignsAds',
      component: CampaignAds,
      props: true,
    }],
  }],
};